import type { FormConfig } from '@tencent/wb-ext-form';
import { FormItemName, FormItemLabelName, FormItemType } from '@framework/workbench/drawer/constants';
import { AngleOptions } from '@framework/workbench/drawer/common/config';

export const ANGLE_MIN = -360;

export const FORM_CONFIGS: FormConfig[] = [
    {
        type: FormItemType.ANGLE,
        name: FormItemName.LAYOUT_ROTATE,
        label: FormItemLabelName.ANGLE,
        options: {
            ...AngleOptions,
            min: ANGLE_MIN,
            maxLength: 5,
        },
        style: {
            maxWidth: 160,
        },
        defaultValue: 0,
    },
];
